import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledNotAllowedRenewalTrigger = styled(Button)(
    ({theme: {palette}}) => css`
        font-weight: 400;
        width: 100%;
        justify-content: flex-start;
        border-radius: 0;

        color: ${palette.neutral['950']};
        & > svg {
            fill: ${palette.neutral['500']};
        }
        &[aria-disabled='true'] {
            color: ${palette.neutral['400']};
            & > svg {
                fill: ${palette.neutral['300']};
            }
        }

        &:hover {
            color: ${palette.neutral['950']};
            background-color: ${palette.neutral['100']};
        }
    `
)
